import 'core-js/stable';
import 'regenerator-runtime/runtime';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import {Power3, Power4, Strong, Linear} from "gsap";
import slick from "slick-carousel/slick/slick";
import Inputmask from "../.../../../node_modules/inputmask/dist/jquery.inputmask.min";
import SplitType from 'split-type'
import Lenis from '@studio-freight/lenis'

 $(".inputmask").inputmask({"mask": "+7 (999) 999-9999"});


gsap.registerPlugin(ScrollTrigger);




ScrollTrigger.matchMedia({
	"(min-width: 992px)" : function() {


		const splitTypes = document.querySelectorAll('.reveal-type')

		splitTypes.forEach((char,i) => {

		const bg = char.dataset.bgColor
		const fg = char.dataset.fgColor

		const text = new SplitType(char, { types: 'chars'})

		gsap.fromTo(text.chars, 
				{
					// color: bg,
					y: 50,
					opacity: 0
				},
				{
					// color: fg,
					duration: 0.7,
					stagger: 0.01,
					y: 0,
					opacity: 1,
					scrollTrigger: {
						trigger: char,
						start: 'top 80%',
						end: 'top 20%',
						// scrub: true,
						markers: false,
						// toggleActions: 'play play reverse reverse'
						toggleActions: 'play none none none'
					}
			})
		})


		const lenis = new Lenis({});

		//get scroll value
		// lenis.on("scroll", (e) => {
		// 	console.log(e);
		// });

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}

		requestAnimationFrame(raf); 




		const heroAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: ".hero",
				toggleActions: "play none none none",
			},
			repeat: 0,
			repeatDelay: 1
		});



		heroAnimation.to(".loaderblock__char", {
			opacity: 1,
			stagger: 0.07,
			ease: Power4.easeIn
			// ease: "power3.out"
		})

		heroAnimation.to(".loaderblock__char", {
			opacity: 0,
			stagger: 0.07,
			ease: Power4.easeIn
			// ease: "power3.out"
		})


		heroAnimation.to(".loaderblock__item", {
			scaleY: 0,
			stagger: 0.1,
			ease: "power3.out"
			// ease: "power3.out"
		})

		heroAnimation.to(".loaderblock", {
			display: "none",
			// ease: "power3.out"
		})


		heroAnimation.fromTo(".heroanimation", {
			opacity: 0
		}, {
			opacity: 1,
			stagger: 0.2,
		}, '-=0.5')



		const catalogIndex = gsap.timeline({
			scrollTrigger: {
				trigger: ".catalog",
				toggleActions: "play none none none",
				// scrub: true,
				// markers: true,
				start: 'top 40%',
				end: 'top 20%',
			},
			repeat: 0,
			repeatDelay: 1,
			
		});

		catalogIndex.fromTo('.catalog__product', {
			opacity: 0
		}, {
			ease: Power4.easeIn,
			duration: .5,
			opacity: 1,
			stagger: 0.2
		})




		const advantages = gsap.timeline({
			scrollTrigger: {
				trigger: ".advantages",
				toggleActions: "play none none none",
				// scrub: true,
				// markers: true,
				start: 'top 40%',
				end: 'top 20%',
			},
			repeat: 0,
			repeatDelay: 1,
			
		});

		advantages.fromTo('.advantages__card', {
			opacity: 0,
			y: 20
		}, {
			ease: Power4.easeIn,
			duration: .5,
			opacity: 1,
			y: 0,
			stagger: 0.2
		})

		advantages.fromTo('.advantheader__image img', {
			scale: 1.5
		}, {
			// ease: Power4.easeIn,
			scale: 1
		}, '-=0.5')


		


		const scopeApp = gsap.timeline({
			scrollTrigger: {
				trigger: ".scope-application",
				toggleActions: "play none none none",
				// scrub: true,
				// markers: true,
				start: 'top 40%',
				end: 'top 20%',
			},
			repeat: 0,
			repeatDelay: 1,
			
		});

		scopeApp.fromTo('.scope-application__card', {
			opacity: 0,
			y: 20
		}, {
			ease: Power4.easeIn,
			duration: .5,
			opacity: 1,
			y: 0,
			stagger: 0.2
		})


		const documents = gsap.timeline({
			scrollTrigger: {
				trigger: ".documents",
				toggleActions: "play none none none",
				// scrub: true,
				// markers: true,
				start: 'top 40%',
				end: 'top 20%',
			},
			repeat: 0,
			repeatDelay: 1,
			
		});

		documents.fromTo('.documents__intro', {
			opacity: 0,
			y: 20
		}, {
			duration: .5,
			opacity: 1,
			y: 0,
		})

		documents.fromTo('.documents__image', {
			opacity: 0,
		}, {
			opacity: 1,
		})


		documents.fromTo('.documents__docs li', {
			opacity: 0,
		}, {
			opacity: 1,
			stagger: 0.2
		})


		const ourprojectsAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: ".ourprojectsAnimation",
				toggleActions: "play none none none",
				// scrub: true,
				// markers: true,
				start: 'top 80%',
				end: 'top 20%',
			},
			repeat: 0,
			repeatDelay: 1,
		});

		ourprojectsAnimation.fromTo('.ourprojectsAnimation', {
			opacity: 0,
			y: 120
		}, {
			duration: 1,
			opacity: 1,
			y: 0,
		})


		const articlesblockAnimation = gsap.timeline({
			scrollTrigger: {
				trigger: ".articlesblockAnimation",
				toggleActions: "play none none none",
				// scrub: true,
				// markers: true,
				start: 'top 80%',
				end: 'top 20%',
			},
			repeat: 0,
			repeatDelay: 1,
		});

		articlesblockAnimation.fromTo('.articlesblockAnimation', {
			opacity: 0,
			y: 120
		}, {
			duration: 1,
			opacity: 1,
			y: 0,
		})


		// const blogPage = gsap.timeline({
		// 	scrollTrigger: {
		// 		trigger: ".blog-page__container",
		// 		toggleActions: "play none none none",
		// 		scrub: true,
		// 		// markers: true,
		// 		start: 'top 40%',
		// 		end: 'top 20%',
		// 	},
		// 	repeat: 0,
		// 	repeatDelay: 1,
		// });

		// blogPage.fromTo('.blog-page .article', {
		// 	opacity: 0,
		// 	y: 120
		// }, {
		// 	duration: 1,
		// 	opacity: 1,
		// 	y: 0,
		// 	stagger: 0.2
		// })




		

		






		
/*
		const tween = gsap.timeline({
			scrollTrigger: {
				trigger: ".main",
				toggleActions: "play reverse restart reset",
			},
			repeat: 0,
			repeatDelay: 1
		});

		tween.to(".main", {
			duration: 0.5,
			opacity: 1,
			//ease: "bounce"
		})

		tween.to(".header", {
			duration: 0.75,
			opacity: 1,
			translateY: 0,
		}, '-=0.25') // Когда прошла 0.25 секунды анимации .main начинаем анимацию .header


		tween.to(".left-panel", {
			duration: 0.5,
			opacity: 1,
			translateX: 0,
		}, '-=0.5')

		tween.to(".main__title", {
			duration: 1,
			opacity: 1,
			translateY: 0
		}, '-=0.25')

		tween.to(".main__title span", {
			duration: 1,
			color: "#CFA604"
		}, '-=0.45')

		tween.to(".main__btns", {
			duration: 1,
			opacity: 1,
			translateY: 0
		}, '-=1.2')

		tween.to(".main__advantage-item", {
			duration: 1,
			opacity: 1,
			translateY: 0,
			stagger: 0.2,
		}, '-=0.7')


		tween.to(".main__coube", {
			duration: 0.7,
			opacity: 1,
			scale: 1,
			stagger: 0.1,
		}, '-=0.7')


		tween.to(".left-panel__social", {
			duration: 1.5,
			opacity: 1,
			translateY: 0,
			ease: "bounce",
		})


		gsap.to(".service-box",{
			scrollTrigger: {
				trigger: ".services",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1.5,
			scale: 1,
			opacity: 1,
			stagger: 0.2
		});

		gsap.to(".reviews .container",{
			scrollTrigger: {
				trigger: ".reviews",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1,
			y: 0,
			opacity: 1
		});


		gsap.to(".portfolio .container",{
			scrollTrigger: {
				trigger: ".portfolio",
				toggleActions: "play reverse restart reset",
				scrub: 1,
				end: "bottom bottom",
			},
			duration: 1,
			y: 0,
			opacity: 1
		});




		const company = gsap.timeline({
			scrollTrigger: {
				trigger: ".company",
				toggleActions: "play reverse restart reset",
				scrub: 2,
				start: "top center",
				end: "bottom bottom",
			},
			repeat: 0,
			repeatDelay: 1
		});

		company.to(".company__image", {
			duration: 0.5,
			opacity: 1,
			translateX: 0
		})

		company.to(".company__container", {
			duration: 0.5,
			opacity: 1,
			translateY: 0
		}, "-=0.5")


		ScrollTrigger.batch(".calculator__item", {
			onEnter: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				y: 0,
				stagger: 0.1,
			}),
		});

		ScrollTrigger.batch(".article", {
			onEnter: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				y: 0,
				stagger: 0.1,
			}),
			onLeave: batch => gsap.to(batch, {
				opacity: 0,
				scale: 1.5,
				stagger: 0.1
			}),
			onEnterBack: batch => gsap.to(batch, {
				opacity: 1,
				scale: 1,
				stagger: 0.1
			}),
			onLeaveBack: batch => gsap.to(batch, {
				opacity: 0,
				scale: 1.5,
				stagger: 0.1
			}),
		});*/

	}
})


svg4everybody();

window.$ = $;
window.jQuery = $;
window.gsap = gsap;


